export default "__VITE_ASSET__CnopUj43__"